import { AllSameKeyValuesEnforcer } from '../helpers/helpers'
import { addExcludedEntityTemplateKeys, addPublicEntityKeys, EntityBase } from './entity.shared.data';
import { JoiFile } from './files.model';
import { createId } from '../helpers/helpers';
import { FilterGroup } from './filters.data';
import { Budget } from './budget.data';


export interface ResourceTabs { details, assets, schedule, quotes, quickNotes, contact, tasks, infoForResource, configBrief, preview }
export const resourceTabs: AllSameKeyValuesEnforcer<ResourceTabs> = { details: 'details', assets: 'assets', schedule: 'schedule', quotes: 'quotes', quickNotes: 'quickNotes', infoForResource:'infoForResource', configBrief:'configBrief', preview:'preview', contact: 'contact', tasks: 'tasks' }

export interface ResourceContact { // separate from / can overlap user or workforce member
  id: string // NOT a user id
  photoURL?: string
  firstName?: string
  lastName?: string
  role?: string
	aboutMe?: string
	company?: string
	title?: string
	phone?: string
  email?: string
  address?: string
}

export const createResourceContact = (): ResourceContact => ({
  id: createId()
})


export interface JoiResource extends EntityBase {
  about?: string
  briefed?: boolean
  workforceContactEmail?: string
  primaryContactId: string
  contacts: ResourceContact[]
  quoteIds: string[]

  files?: JoiFile[]
  assetIds?: string[]
  showEditProfileLinkInBrief?: boolean // when active, of course.  This needs to be moved here because this option can be toggled to true before the performer brief shareable is created...
  showAssetsLinkInBrief?: boolean
  photoHidden?: boolean
}

export interface DeleteResourcesData {
  eventId: string
  resourceIds: string[]
}

export interface RenameResourceData {
  eventId: string
  resourceId: string
  name: string
}

export const publicResourceKeys: Set<keyof JoiResource> = new Set(['about',  'primaryContactId', 'contacts', 'workforceContactEmail', 'quoteIds'])
addPublicEntityKeys(publicResourceKeys)

export const excludedTemplateResourceProps: Set<keyof JoiResource> = new Set(['briefed', 'showEditProfileLinkInBrief', 'photoHidden'] )
addExcludedEntityTemplateKeys(excludedTemplateResourceProps)

export const filterResources = (filters: FilterGroup, resourceList: JoiResource[]): JoiResource[] => {
  resourceList = resourceList.filter(r => ![
    () => !filters.resourceLabels || (r.labels && r.labels.some(l => filters.resourceLabels.includes(l))),
    () => !filters.tags || (r.workforceContactEmail && filters.tags.includes(r.workforceContactEmail))
  ].some(passesFilterFunction => !passesFilterFunction()))
  return resourceList
}

export const getResourcesWithQuotes = (resourceList: JoiResource[], budget: Budget): JoiResource[] => {
  if (!budget) return []
  const quoteIds = new Set(Object.keys(budget.quotes))
  return resourceList.filter(r => r.quoteIds.some(id => quoteIds.has(id)))
}

export const createBaseResource = (idCreator: () => string): JoiResource => ({
  id: idCreator(),
  social: [],
  labels: [],
  files: [],
  contacts: [],
  assetIds: [],
  quoteIds: [],
  primaryContactId: idCreator(),
  customQuestions: {},
  name: ''
})